/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiPermission } from '@Model';
import type { HttpActions, ListInfo, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of PermissionsController.
 */
export class PermissionsRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls GET /permissions:query
     */
    public getAll(): Promise<Result<ListInfo<ApiPermission>>> {
        return this.http.get<Result<ListInfo<ApiPermission>>>('/permissions:query');
    }

    /**
     * Calls POST /permissions:query
     */
    public getList(): Promise<Result<ListInfo<ApiPermission>>> {
        return this.http.post<Result<ListInfo<ApiPermission>>, undefined>('/permissions:query', undefined);
    }
}
